import React from "react";
import { CampaignState, EXPIRED_CAMPAIGN_MESSAGE, NOT_STARTED_CAMPAIGN_MESSAGE } from "@constants/consts";
import * as Styled from "./UnavailableMessage.styled";

interface UnavailableMessageProps {
  campaignStatus?: CampaignState;
}

const UnavailableMessage: React.FC<UnavailableMessageProps> = ({ campaignStatus }) => {
  if (!campaignStatus || campaignStatus === CampaignState.ACTIVE) return null;

  return (
    <Styled.UnavailableMessageContainer>
      <Styled.UnavailableIcon />
      <Styled.UnavailableMessage>
        {campaignStatus === CampaignState.EXPIRED ? EXPIRED_CAMPAIGN_MESSAGE : NOT_STARTED_CAMPAIGN_MESSAGE}
      </Styled.UnavailableMessage>
    </Styled.UnavailableMessageContainer>
  );
};

export default UnavailableMessage;
